import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { cn } from '@/lib/utils'
import { useBranding } from '@utils/api'
import Loading from '@components/Loading'
import GuidedBookingWizard from '@components/GuidedBookingWizard'

type GuidedBookingSearch = {
  token?: string
}

export const Route = createFileRoute('/guidedBooking')({
  component: GuidedBooking,
  validateSearch: (search: Record<string, unknown>): GuidedBookingSearch => {
    return {
      token: search.token as string | undefined,
    }
  },
})

function GuidedBooking() {
  const navigate = useNavigate()
  const { token } = useSearch({ from: '/guidedBooking' })
  const { branding, isLoading, isError } = useBranding()
  const { i18n } = useTranslation()
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (branding && branding.supportedLanguages.includes(navigator.language)) {
      i18n.changeLanguage(navigator.language)
    } else if (
      branding &&
      branding.supportedLanguages.includes(navigator.language.split('-')[0])
    ) {
      i18n.changeLanguage(navigator.language.split('-')[0])
    }
  }, [i18n, branding])

  useEffect(() => {
    if (branding) {
      setIsVisible(true)
    }
  }, [branding])

  // Redirect if no token
  useEffect(() => {
    if (!token) {
      navigate({ to: '/' })
    }
  }, [token, navigate])

  if (isLoading) return <Loading />
  if (isError) {
    navigate({ to: '/' })
    return null
  }
  if (!token) return <Loading />

  return (
    <div
      className={cn(
        'min-h-[100svh] w-full flex items-center justify-center',
        'p-4 transition-opacity duration-500 ease-in-out',
        isVisible ? 'opacity-100' : 'opacity-0'
      )}
    >
      <GuidedBookingWizard />
    </div>
  )
}
